import { IonAlert } from '@ionic/react'
import { t } from 'helpers/i18n'

export default function ({ isOpen, onCancel, onSubmit = () => {} }) {
  return (
    <IonAlert
      cssClass="tofino-required-alert"
      backdropDismiss={false}
      isOpen={isOpen}
      header={t('packingListNumber')}
      inputs={[{ name: 'input', type: 'text' }]}
      buttons={[
        { text: t('cancel'), role: 'cancel' },
        {
          text: t('add'),
          handler: ({ input }) => {
            onSubmit(input)
            return false
          },
        },
      ]}
      onDidDismiss={onCancel}
    />
  )
}
